import { Owner } from './Owner.model';
import { Phone } from './Phone.model';
import { Address } from './Address.model';
import { Email } from './Email.model';
import { CompanyGroup } from './CompanyGroup.model';
import { GroupDivision } from '../shared/enums/GroupDivision';
import { GroupOrigin } from '../shared/enums/GroupOrigin';
import { ExternalReferenceFinancial } from './ExternalReference.model';
import { Payment } from './Payment.model';
import * as _ from 'lodash';
import { Industry } from './Industry.model';

export class Margins {
    value: number = 0;
    percentage: number = 0;
}

export class BillingProject {
    _id: string;
    name: string;
}

export class Company {

    _id: string;
    active: boolean;
    companyName: string;
    name: string;
    group: GroupDivision = 0;
    created: Date;
    changed: Date;
    origin: GroupOrigin = 0;
    owner: Owner = new Owner();
    ownerSegment: Number = 0;
    manager: Owner = new Owner();
    industry: Industry = new Industry();
    phones: String[] = new Array<String>();
    emails: String[] = new Array<String>();
    cnpj: String;
    validated: Boolean;
    inscriptionEstadual: String;
    inscriptionMunicipal: String;
    x3Id: String;
    integrated: Boolean;
    description: String;
    start: string;
    end: string;
    externalReference: ExternalReferenceFinancial = null;
    companyGroup: CompanyGroup = new CompanyGroup();
    address: Address = new Address();
    payment: Payment = new Payment();
    sapCardCode: String;
    generatedContract: boolean;
    typeContract: String = '';
    subscriber: String;
    subscriberEmail: String;
    isCustomer: Boolean;
    defaultItems: String[];
    tenantId : String;
    margins : Margins[] = new Array<Margins>();
    billingType : string = 'monthly';
    billingProject : BillingProject = new BillingProject();
    omnikIntegrationYear: String;
    isOmnikIntegration: Boolean;
    minValue: number = 0;
    contractStart: string;
    contractEnd: string;

    constructor(data?) {
        this.populate(data);
    }

    populate(data) {
        _.forOwn(data, (value, key) => {
            this[key] = value;
        });
    }

    loadCompanyForGrid(r: any) {

        if (r._id)
            this._id = r._id;

        if (r.name)
            this.name = r.name;

        if (r.owner)
            this.owner.loadOwnerFromServer(r.owner);

        if (r.group)
            this.group = r.group;

        if (r.industry)
            this.industry = r.industry;

        if (r.cnpj)
            this.cnpj = r.cnpj;

        if (r.active)
            this.active = r.active;

        if (r.externalReference) {
            this.externalReference = new ExternalReferenceFinancial();
            this.externalReference.loadExternalReference(r.externalReference)
        }

        if(r.sapCardCode){
            this.sapCardCode = r.sapCardCode;
        }
    }

    loadToEdit(r: any) {
        if (r._id)
            this._id = r._id;

        if (r.active)
            this.active = r.active;

        if (r.companyName)
            this.companyName = r.companyName;

        if (r.name)
            this.name = r.name;

        if (r.group)
            this.group = r.group;

        if (r.created)
            this.created = r.created;

        if (r.changed)
            this.changed = r.changed;

        if (r.origin)
            this.origin = r.origin;

        if (r.phones)
            this.phones = r.phones;

        if (r.emails)
            this.emails = r.emails;

        if (r.cnpj)
            this.cnpj = r.cnpj;

        if (r.validated)
            this.validated = r.validated;

        if(r.industry)
            this.industry.loadIndustry(r.industry);

        if (r.inscriptionEstadual)
            this.inscriptionEstadual = r.inscriptionEstadual;

        if (r.inscriptionMunicipal)
            this.inscriptionMunicipal = r.inscriptionMunicipal;

        if (r.x3Id)
            this.x3Id = r.x3Id;

        if (r.integrated)
            this.integrated = r.integrated;

        if (r.description)
            this.description = r.description;

        if (r.owner)
            this.owner.loadOwnerFromServer(r.owner);

        if(r.ownerSegment)
            this.ownerSegment = r.ownerSegment;

        if(r.manager)
            this.manager.loadOwnerFromServer(r.manager);

        if (r.start)
            this.start = r.start;

        if (r.end)
            this.end = r.end;

        if (r.externalReference) {
            this.externalReference = new ExternalReferenceFinancial();
            this.externalReference.loadExternalReference(r.externalReference);
        }

        if(r.companyGroup)
            this.companyGroup.loadGroups(r.companyGroup);

        if(r.address)
            this.address.loadToEdit(r.address);

        if (r.payment)
            this.payment.loadToEdit(r.payment);

        if (r.sapCardCode)
            this.sapCardCode = r.sapCardCode;

        if(r.generatedContract)
            this.generatedContract = r.generatedContract;

        if(r.typeContract)
            this.typeContract = r.typeContract;

        if(r.subscriber)
            this.subscriber = r.subscriber;

        if(r.subscriberEmail)
            this.subscriberEmail = r.subscriberEmail;

        if (r.hasOwnProperty('isCustomer')) {
            this.isCustomer = r.isCustomer;
        }

        if (r.defaultItems)
            this.defaultItems = r.defaultItems;

        if (r.tenantId)
            this.tenantId = r.tenantId;

        if(r.margins)
            this.margins = r.margins;

        if(r.billingType)
            this.billingType = r.billingType;

        if(r.billingProject)
            this.billingProject = r.billingProject;

        if(r.minValue)
            this.minValue = r.minValue;

        if(r.isOmnikIntegration)
            this.isOmnikIntegration = r.isOmnikIntegration;

        if(r.contractStart)
            this.contractStart = r.contractStart;

        if(r.contractEnd)
            this.contractEnd = r.contractEnd;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/Company.model.ts